export default __webpack_public_path__ + "static/media/loading.67184638.mp4";